import moment from 'moment-timezone';
import { WithTranslation } from 'react-i18next';

import { RelativeDateTime } from 'models/commons';

export const getRelativeDateDescription = (
  relativeDate: RelativeDateTime,
  t: WithTranslation['t'],
  locale: string
): string => {
  if (relativeDate.type === 'DAY') {
    if (relativeDate.count === 0) {
      return t('{{time}} on day of participation', {
        time: moment(relativeDate.time_local, 'H:mm').locale(locale).format('LT'),
      });
    }

    return t('{{count}} days before participation at {{time}}', {
      count: relativeDate.count || 0,
      time: moment(relativeDate.time_local, 'H:mm').locale(locale).format('LT'),
    });
  }

  return t('{{count}} hours before participation', {
    count: relativeDate.count || 0,
  });
};
